namespace nscs.sound {
    export class SoundManager {

        private static _instance:SoundManager = null;
        public static getInstance():SoundManager {
            if (!SoundManager._instance) {
                SoundManager._instance = new SoundManager(game.scene.getAt(0));
            }
            return SoundManager._instance;
        }

        private music = null;
        private sounds: Array<Phaser.Sound.BaseSound> = [];

        public muted: boolean = false;

        private currentMusic: string = "";

        private scene: Phaser.Scene;

        constructor(scene: Phaser.Scene) {
            this.scene = scene;
        }

        public playMusic(filename: string, loop: boolean = false): void {
            if (this.currentMusic == filename) {
                return;
            }
            this.stopMusic();
            this.music = this.scene.sound.add(filename);
            this.music["filename"] = filename;
            this.music.loop = loop;
            this.music.play();
            this.music.setVolume(this.muted ? 0 : 1);
            this.currentMusic = filename;
        }

        public stopMusic(): any {
            this.currentMusic = "";
            if (this.music) this.music.stop();
        }

        public mute(): void {
            if (this.muted) {
                this.muted = false;
                if (this.music) this.revertMusic(1000);
            } else {
                this.muted = true;
                if (this.music) this.fadeMusic(null, 1000);
            }
        }

        public playSound(filename: string, volume:number = 1): void {
            let snd:string = filename;
            try {
                let s: any = this.scene.sound.add(snd);
                s["filename"] = filename;
                s.play();
                if (this.muted) {
                    s.setVolume(0);
                } else {
                    s.setVolume(volume);
                }
                this.sounds.push(s);
            } catch {
            }
        }

        public stopSound(): void {
            for (let s of this.sounds) s.stop();
        }

        public fadeMusic(to: string, time: number, loop: boolean = false): void {
            if (this.currentMusic == to) return;

            if (this.music) {
                let _music = this.music;
                this.scene.tweens.add({
                    targets: _music,
                    "volume": 0,
                    duration: time,
                    ease: Phaser.Math.Easing.Linear,
                    onComplete: () => {
                        if (to) _music.stop();
                    }
                });
                if (to) {
                    this.music = null;
                    this.currentMusic = null;
                }
            }

            if (!to) return;

            this.playMusic(to, loop);
            this.music.setVolume(0);
            if (!this.muted) {
                this.scene.tweens.add({
                    targets: this.music,
                    "volume": 1,
                    duration: time,
                    ease: Phaser.Math.Easing.Linear
                });
            }
        }

        public revertMusic(time: number): void {
            if (this.music) {
                let _music = this.music;
                this.scene.tweens.add({
                    targets: _music,
                    "volume": this.muted ? 0 : 1,
                    duration: time,
                    ease: Phaser.Math.Easing.Linear
                });
            }
        }
    }
}
